import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { usePDF } from 'react-to-pdf';
import HeaderOfPage from "../tools/headerOfPage";

const SENDER = {
    address: 'تهران کیلومتر ۷ بزرگراه فتح (متوسلیان) جنب صنعتی بهشر هایپر نانو جهانبخش',
    postalcode: '1386936174',
    phone: '09921002123',
};

/** Physical label paper: 10cm × 15cm (width × height, portrait) */
const LABEL_W = 100;
const LABEL_H = 150;
const PAGE_FORMAT: [number, number] = [LABEL_W, LABEL_H];

export default function InvoiceLabelSimple() {
    const breadcrump = [
        { name: 'Dashboard', url: '/dashboard' },
        { name: 'َکاربران', url: '/dashboard/user' },
        { name: 'لیست فاکتور', url: '/dashboard/user/invoices' },
        { name: 'لیبل ۱۰×۱۵', url: null },
    ];

    return (
        <div className="text-left directions bg-white p-4 sm:p-6 m-4 rounded-xl shadow-sm border border-gray-100 min-h-[calc(100vh-2rem)] mb-5">
            <BreadCrump data={breadcrump} />
            <HeaderOfPage name="لیبل ساده ۱۰×۱۵" />
            <LabelContent />
        </div>
    );
}

function LabelContent() {
    const { t } = useTranslation();
    const { Id } = useParams();
    const cookie = getCookies();
    const [invoice, setInvoice] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    const { toPDF, targetRef } = usePDF({
        filename: 'label-10x15.pdf',
        page: {
            format: PAGE_FORMAT,
            orientation: 'portrait',
        },
    });

    const getalldata = async () => {
        setLoading(true);
        try {
            const res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/invoices/' + Id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                },
            });
            setInvoice(res.data.message);
        } catch (error) {
            // ignore
        } finally {
            setLoading(false);
        }
    };

    const toJalali = (date: string) => {
        return new Date(date).toLocaleString('fa-IR', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        });
    };

    const formatPrice = (price: number | string) => {
        const num = Number(price);
        if (Number.isNaN(num)) return String(price);
        return num.toLocaleString('fa-IR');
    };

    const fullName = () => {
        const name = [invoice?.touser?.name, invoice?.touser?.lastname].filter(Boolean).join(' ').trim();
        return name || invoice?.touser?.mobile || '—';
    };

    const getProductCode = (product: any) => product?.alt || product?.code || null;

    const getFeatureValue = (product: any, keys: string[]) => {
        const features = product?.feature;
        if (!features || typeof features !== 'object') return null;
        for (const key of keys) {
            if (features[key] != null && features[key] !== '') return String(features[key]);
        }
        for (const [key, value] of Object.entries(features)) {
            if (keys.some((k) => key.includes(k)) && value != null && value !== '') {
                return String(value);
            }
        }
        return null;
    };

    const invoiceRows = () => {
        const rows: {
            title: string;
            meta: string[];
            count: number;
            price: number;
            total: number;
        }[] = [];

        invoice?.details?.forEach((detail: any) => {
            const product = detail?.product;
            const productName = product?.name?.trim() || '';
            const code = getProductCode(product);
            const model = getFeatureValue(product, ['مدل', 'model']);
            const brandName = product?.toBrand?.name || product?.brand?.name || null;
            const extraFeatures = product?.feature && typeof product.feature === 'object'
                ? Object.entries(product.feature)
                    .filter(([key, value]) => {
                        if (value == null || value === '') return false;
                        if (key.includes('مدل') || key.toLowerCase().includes('model')) return false;
                        return true;
                    })
                    .map(([key, value]) => `${key}: ${value}`)
                : [];

            detail?.detail?.item?.forEach((row: any) => {
                const count = Number(row.count) || 0;
                const price = Number(row.price) || 0;
                const rowName = String(row.name || '').trim();
                const title = productName || rowName || '—';
                const meta: string[] = [];

                if (rowName && productName && rowName !== productName) {
                    meta.push(`شرح: ${rowName}`);
                }
                if (code) meta.push(`کد: ${code}`);
                if (row.code && String(row.code) !== String(code)) meta.push(`کد آیتم: ${row.code}`);
                if (model) meta.push(`مدل: ${model}`);
                if (row.model) meta.push(`مدل: ${row.model}`);
                if (brandName) meta.push(`برند: ${brandName}`);
                if (row.color) meta.push(`رنگ: ${row.color}`);
                if (row.description) meta.push(String(row.description));
                if (row.unit && row.unit !== 'unit') meta.push(`واحد: ${row.unit}`);
                if (row.amount) meta.push(`مقدار: ${row.amount}`);
                extraFeatures.forEach((f) => meta.push(f));

                // Any other useful string fields on the row
                const skipKeys = new Set([
                    'name', 'color', 'count', 'price', 'code', 'model',
                    'description', 'unit', 'amount', 'id', '_id', 'product',
                    'total', 'totalprice',
                ]);
                Object.entries(row || {}).forEach(([key, value]) => {
                    if (skipKeys.has(key)) return;
                    if (value == null || value === '') return;
                    if (typeof value === 'object') return;
                    meta.push(`${key}: ${value}`);
                });

                rows.push({
                    title,
                    meta,
                    count,
                    price,
                    total: price * count,
                });
            });
        });
        return rows;
    };

    useEffect(() => {
        getalldata();
    }, []);

    if (loading) {
        return (
            <div className="py-16 text-center text-sm text-gray-500" dir="rtl">
                در حال بارگذاری...
            </div>
        );
    }

    if (!invoice) {
        return (
            <div className="py-16 text-center text-sm text-gray-500" dir="rtl">
                فاکتور یافت نشد
            </div>
        );
    }

    const rows = invoiceRows();

    const printLabel = () => {
        const sheet = targetRef.current;
        if (!sheet) return;

        const iframe = document.createElement('iframe');
        iframe.setAttribute('aria-hidden', 'true');
        iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none;';
        document.body.appendChild(iframe);

        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (!doc) {
            document.body.removeChild(iframe);
            window.print();
            return;
        }

        doc.open();
        doc.write(`<!DOCTYPE html><html dir="rtl"><head><meta charset="utf-8"/><title>label</title>
<style>
  @page {
    size: ${LABEL_W}mm ${LABEL_H}mm;
    margin: 0;
  }
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    width: ${LABEL_W}mm !important;
    height: ${LABEL_H}mm !important;
    overflow: hidden !important;
    background: #fff !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  *, *::before, *::after {
    box-sizing: border-box !important;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }
  *::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .label-sheet {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: ${LABEL_W}mm !important;
    height: ${LABEL_H}mm !important;
    max-width: none !important;
    max-height: none !important;
    margin: 0 !important;
    padding: 2.5mm !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
    border: 1px solid #000 !important;
    background: #fff !important;
    transform: none !important;
  }
</style></head><body></body></html>`);
        doc.close();

        const clone = sheet.cloneNode(true) as HTMLElement;
        clone.classList.add('label-sheet');
        clone.style.cssText = [
            'position:fixed',
            'top:0',
            'left:0',
            `width:${LABEL_W}mm`,
            `height:${LABEL_H}mm`,
            'margin:0',
            'max-width:none',
            'max-height:none',
            'overflow:hidden',
            'box-sizing:border-box',
            'padding:2.5mm',
            'display:flex',
            'flex-direction:column',
            'gap:1.5mm',
            'font-family:Tahoma, Arial, sans-serif',
            'color:#000',
            'background:#fff',
            'text-align:right',
            'direction:rtl',
            'border:1px solid #000',
        ].join(';');
        doc.body.appendChild(clone);

        const cleanup = () => {
            if (iframe.parentNode) document.body.removeChild(iframe);
        };

        const doPrint = () => {
            try {
                iframe.contentWindow?.focus();
                iframe.contentWindow?.print();
            } finally {
                setTimeout(cleanup, 1000);
            }
        };

        setTimeout(doPrint, 200);
    };

    return (
        <div className="directions text-right" dir="rtl">
            <style>{`
                @page {
                    size: ${LABEL_W}mm ${LABEL_H}mm;
                    margin: 0;
                }
                @media print {
                    html, body, #root {
                        width: ${LABEL_W}mm !important;
                        height: ${LABEL_H}mm !important;
                        margin: 0 !important;
                        padding: 0 !important;
                        overflow: hidden !important;
                        background: #fff !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    *, *::before, *::after {
                        scrollbar-width: none !important;
                        -ms-overflow-style: none !important;
                    }
                    *::-webkit-scrollbar {
                        display: none !important;
                        width: 0 !important;
                        height: 0 !important;
                        background: transparent !important;
                    }
                    body * {
                        visibility: hidden !important;
                    }
                    #label-print-root,
                    #label-print-root * {
                        visibility: visible !important;
                    }
                    .no-print {
                        display: none !important;
                    }
                    header, aside, nav {
                        display: none !important;
                    }
                    main, main * {
                        overflow: hidden !important;
                        max-height: none !important;
                    }
                    #label-print-root {
                        position: fixed !important;
                        inset: 0 !important;
                        width: ${LABEL_W}mm !important;
                        height: ${LABEL_H}mm !important;
                        margin: 0 !important;
                        padding: 0 !important;
                        overflow: hidden !important;
                        background: #fff !important;
                    }
                    .label-sheet {
                        position: fixed !important;
                        inset: 0 !important;
                        box-shadow: none !important;
                        border: 1px solid #000 !important;
                        width: ${LABEL_W}mm !important;
                        height: ${LABEL_H}mm !important;
                        max-width: none !important;
                        max-height: none !important;
                        margin: 0 !important;
                        overflow: hidden !important;
                        transform: none !important;
                    }
                }
            `}</style>

            <div className="no-print flex flex-wrap items-center justify-end gap-2 pb-4">
                <a
                    href={`/dashboard/User/invoices/${invoice.id}`}
                    className="inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                >
                    {t('بازگشت')}
                </a>
                <button
                    type="button"
                    onClick={printLabel}
                    className="inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-black bg-white text-black hover:bg-gray-100"
                >
                    چاپ مستقیم
                </button>
                <button
                    type="button"
                    onClick={() => toPDF({
                        filename: `label-${invoice.id}.pdf`,
                        page: { format: PAGE_FORMAT, orientation: 'portrait' },
                    })}
                    className="inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg bg-black text-white hover:bg-gray-800"
                >
                    دانلود PDF
                </button>
            </div>

            <div id="label-print-root" dir="rtl">
                <div
                    ref={targetRef}
                    className="label-sheet mx-auto bg-white text-black border border-black"
                    dir="rtl"
                    style={{
                        width: `${LABEL_W}mm`,
                        height: `${LABEL_H}mm`,
                        boxSizing: 'border-box',
                        padding: '2.5mm',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1.5mm',
                        fontFamily: 'Tahoma, Arial, sans-serif',
                        color: '#000',
                        background: '#fff',
                        textAlign: 'right',
                        direction: 'rtl',
                        overflow: 'hidden',
                    }}
                >
                    {/* Header */}
                    <div style={{ borderBottom: '1.5px solid #000', paddingBottom: '1mm', flexShrink: 0 }}>
                        <div style={{ fontSize: '15px', fontWeight: 700, textAlign: 'center' }}>
                            فروشگاه نانو سیلکو
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.8mm', fontSize: '11px', direction: 'rtl' }}>
                            <span>تاریخ: {toJalali(invoice.createdAt)}</span>
                            <span style={{ fontFamily: 'monospace', direction: 'ltr', unicodeBidi: 'embed' }}>
                                #{String(invoice.id).slice(-8)}
                            </span>
                        </div>
                    </div>

                    {/* Receiver */}
                    <div style={{ border: '1.5px solid #000', padding: '1.8mm', flexShrink: 0 }}>
                        <div style={{ fontSize: '12px', fontWeight: 700, marginBottom: '0.8mm' }}>
                            گیرنده: <span style={{ fontSize: '14px' }}>{fullName()}</span>
                        </div>
                        {invoice.address && (
                            <>
                                <div style={{ fontSize: '11px', lineHeight: 1.4, marginBottom: '0.6mm' }}>
                                    <strong>آدرس:</strong>{' '}
                                    {[invoice.address.provinces, invoice.address.city, invoice.address.address]
                                        .filter(Boolean)
                                        .join(' - ')}
                                </div>
                                <div style={{ fontSize: '11px', display: 'flex', justifyContent: 'space-between', gap: '3mm', flexWrap: 'wrap' }}>
                                    {invoice.address.postalcode && (
                                        <span>
                                            <strong>کدپستی:</strong>{' '}
                                            <span style={{ fontFamily: 'monospace', direction: 'ltr', unicodeBidi: 'embed' }}>
                                                {invoice.address.postalcode}
                                            </span>
                                        </span>
                                    )}
                                    {(invoice.touser?.mobile || invoice.address.phone) && (
                                        <span>
                                            <strong>تلفن:</strong>{' '}
                                            <span style={{ direction: 'ltr', unicodeBidi: 'embed' }}>
                                                {invoice.touser?.mobile || invoice.address.phone}
                                            </span>
                                        </span>
                                    )}
                                </div>
                            </>
                        )}
                    </div>

                    {/* Invoice items */}
                    <div style={{ border: '1.5px solid #000', flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 18mm 32mm',
                            fontSize: '11px',
                            fontWeight: 700,
                            borderBottom: '1.5px solid #000',
                            flexShrink: 0,
                        }}>
                            <div style={{ padding: '1.2mm 2mm', textAlign: 'right', borderLeft: '1px solid #000' }}>شرح</div>
                            <div style={{ padding: '1.2mm', textAlign: 'center', borderLeft: '1px solid #000' }}>تعداد</div>
                            <div style={{ padding: '1.2mm', textAlign: 'center' }}>مبلغ</div>
                        </div>
                        <div style={{ flex: 1, overflow: 'hidden', minHeight: 0 }}>
                            {rows.length === 0 && (
                                <div style={{ padding: '1.5mm 2mm', fontSize: '11px' }}>آیتمی ثبت نشده</div>
                            )}
                            {rows.map((row, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 18mm 32mm',
                                        fontSize: '11px',
                                        borderBottom: idx === rows.length - 1 ? 'none' : '1px solid #000',
                                        alignItems: 'stretch',
                                    }}
                                >
                                    <div style={{
                                        padding: '1.2mm 2mm',
                                        textAlign: 'right',
                                        borderLeft: '1px solid #000',
                                        lineHeight: 1.35,
                                        overflow: 'hidden',
                                    }}>
                                        <div style={{ fontWeight: 700, fontSize: '12px' }}>{row.title}</div>
                                        {row.meta.length > 0 && (
                                            <div style={{ marginTop: '0.5mm', fontSize: '10px', opacity: 0.95 }}>
                                                {row.meta.join(' · ')}
                                            </div>
                                        )}
                                    </div>
                                    <div style={{
                                        padding: '1.2mm',
                                        textAlign: 'center',
                                        borderLeft: '1px solid #000',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: 700,
                                    }}>
                                        {row.count.toLocaleString('fa-IR')}
                                    </div>
                                    <div style={{
                                        padding: '1.2mm',
                                        textAlign: 'center',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '11px',
                                    }}>
                                        {formatPrice(row.total)}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: '1.5px solid #000',
                            padding: '1.5mm 2mm',
                            fontSize: '13px',
                            fontWeight: 700,
                            flexShrink: 0,
                        }}>
                            <span>جمع کل</span>
                            <span>{formatPrice(invoice.totalprice)} تومان</span>
                        </div>
                    </div>

                    {/* Sender */}
                    <div style={{ border: '1.5px solid #000', padding: '1.5mm 2mm', flexShrink: 0 }}>
                        <div style={{ fontSize: '10px', lineHeight: 1.4 }}>
                            <strong>فرستنده:</strong> {SENDER.address}
                            {' · '}
                            <span style={{ fontFamily: 'monospace', direction: 'ltr', unicodeBidi: 'embed' }}>{SENDER.postalcode}</span>
                            {' · '}
                            <span style={{ direction: 'ltr', unicodeBidi: 'embed' }}>{SENDER.phone}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
